import { render, staticRenderFns } from "./FullScreenSpinner.vue?vue&type=template&id=2d1b72aa&"
import script from "./FullScreenSpinner.vue?vue&type=script&lang=js&"
export * from "./FullScreenSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports